import React, { useEffect, useState } from "react";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import axios from "../../../../api/axios";
import PricingSubCategoryTab from "./PricingSubCategorTabBR";
import ApplicationStore from "../../../../../src/utils/localStorageUtil";

// ---------------------------------------------------------
// TAB PANEL
// ---------------------------------------------------------
function TabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`pricing-tabpanel-${index}`}
      aria-labelledby={`pricing-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography component="div">
            {children}
          </Typography>
        </Box>
      )}
    </div>
  );
}


// ---------------------------------------------------------
// ACCESSIBILITY PROPS
// ---------------------------------------------------------
function a11yProps(index) {
  return {
    id: `pricing-tab-${index}`,
    "aria-controls": `pricing-tabpanel-${index}`,
  };
}


// ---------------------------------------------------------
// MAIN PRICING TAB
// ---------------------------------------------------------
const PricingTabBR = ({
  packages,
  setPackages,

  packagesTypes,
  setPackagesType,

  productIndex,
  setProductIndex,

  setProductName,
  setProductCost,

  handleNext,

  setPackagesText,

  setGiftCardCredit,
  setOriginalCost,

  productRef,

  setProductMonth,
  setProductKm,

  setDeductibleType,
  setDeductible,
}) => {

  // ---------------------------------------------------------
  // CATEGORY LIST
  // ---------------------------------------------------------
  const [packagesTypesLabel, setPackagesTypesLabel] = useState([]);

  // ---------------------------------------------------------
  // CATEGORY INDEX
  // ALWAYS START FROM 0
  // ---------------------------------------------------------
  const [value, setValue] = useState(0);


  const user_type = ApplicationStore().getStorage("user_type");


  // ---------------------------------------------------------
  // LOAD CATEGORY DATA
  // ---------------------------------------------------------
  useEffect(() => {
    loadCategories();
  }, []);


  const loadCategories = async () => {
    try {
      const response = await axios.get("./category");

      // API may return an array directly or an object containing data
      const responseData = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

      console.log("Categories API response:", response.data);
      console.log("Categories array:", responseData);

      setPackagesTypesLabel(responseData);

      // Initialize category and child indexes
      setValue(0);
      setPackages(0);
      setPackagesType(0);
      setProductIndex(0);

      // Set the first category name
      if (responseData.length > 0) {
        setPackagesText(responseData[0]?.categoryName || "");
      }
    } catch (error) {
      console.error("Error loading pricing categories:", error);
      setPackagesTypesLabel([]);
    }
  };


  // ---------------------------------------------------------
  // CATEGORY CHANGE
  // ---------------------------------------------------------
  const handleChange = (event, newValue) => {

    // -------------------------------------------------------
    // CATEGORY INDEX
    // -------------------------------------------------------
    setValue(newValue);
    setPackages(newValue);

    // -------------------------------------------------------
    // RESET SUBCATEGORY
    // -------------------------------------------------------
    setPackagesType(0);

    // -------------------------------------------------------
    // RESET PRODUCT
    // -------------------------------------------------------
    setProductIndex(0);

    // -------------------------------------------------------
    // CATEGORY NAME
    // -------------------------------------------------------
    if (packagesTypesLabel[newValue]) {
      setPackagesText(
        packagesTypesLabel[newValue]?.categoryName || ""
      );
    }
  };


  // ---------------------------------------------------------
  // GET DEALERSHIP
  // ---------------------------------------------------------
  const getDealership = () => {
    try {
      return ApplicationStore?.getState?.()?.dealership || "";
    } catch (error) {
      return "";
    }
  };


  const dealership = getDealership();


  // ---------------------------------------------------------
  // CHECK CATEGORY VISIBILITY
  // ---------------------------------------------------------
  const isCategoryVisible = (category) => {

    // If no visibility configuration exists,
    // show the category.

    // Admin can see all categories regardless of dealership visibility
    if (user_type === "admin") {
      return true;
    }

    if (
      category?.dealershipVisiblity === undefined ||
      category?.dealershipVisiblity === null ||
      category?.dealershipVisiblity === ""
    ) {
      return true;
    }

    try {

      let visibility = category.dealershipVisiblity;

      // Sometimes API returns JSON string
      if (typeof visibility === "string") {
        visibility = JSON.parse(visibility);
      }

      // Array format
      if (Array.isArray(visibility)) {

        return visibility.some((item) => {

          if (typeof item === "string") {
            return item === dealership;
          }

          return (
            item?.dealership === dealership ||
            item?.dealershipId === dealership ||
            item?.id === dealership
          );
        });
      }

      // Object format
      if (typeof visibility === "object") {

        if (
          visibility[dealership] !== undefined
        ) {
          return Boolean(
            visibility[dealership]
          );
        }

        if (
          visibility?.dealership === dealership
        ) {
          return true;
        }

        if (
          visibility?.dealershipId === dealership
        ) {
          return true;
        }
      }

      // String format
      if (typeof visibility === "string") {
        return visibility
          .split(",")
          .map((item) => item.trim())
          .includes(String(dealership));
      }

    } catch (error) {

      console.error(
        "Error checking category visibility:",
        error
      );
    }

    return true;
  };


  // ---------------------------------------------------------
  // FILTER VISIBLE CATEGORIES
  // ---------------------------------------------------------
  const visibleCategories = (
    Array.isArray(packagesTypesLabel) ? packagesTypesLabel : []
  ).filter((category) => isCategoryVisible(category));


  // ---------------------------------------------------------
  // SAFETY
  // ---------------------------------------------------------
  if (!visibleCategories.length) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>
          No pricing categories available.
        </Typography>
      </Box>
    );
  }


  // ---------------------------------------------------------
  // RENDER
  // ---------------------------------------------------------
  return (
    <Box sx={{ width: "100%" }}>

      {/* ---------------------------------------------------
          CATEGORY TABS
      --------------------------------------------------- */}
      <AppBar
        position="static"
        color="default"
        elevation={0}
      >

        <Tabs
          value={
            value < visibleCategories.length
              ? value
              : 0
          }
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="pricing categories"
        >

          {visibleCategories.map(
            (label, index) => (

              <Tab
                key={
                  label?.id ??
                  `category-${index}`
                }
                label={
                  label?.categoryName || ""
                }
                {...a11yProps(index)}
              />

            )
          )}

        </Tabs>

      </AppBar>


      {/* ---------------------------------------------------
          CATEGORY CONTENT
      --------------------------------------------------- */}
      {visibleCategories.map(
        (label, index) => (

          <TabPanel
            key={
              label?.id ??
              `category-panel-${index}`
            }
            value={value}
            index={index}
          >

            <PricingSubCategoryTab
              categoryId={label?.id}

              packagesTypes={
                packagesTypes
              }

              setPackagesType={
                setPackagesType
              }

              productIndex={
                productIndex
              }

              setProductIndex={
                setProductIndex
              }

              setProductName={
                setProductName
              }

              setProductCost={
                setProductCost
              }

              setGiftCardCredit={
                setGiftCardCredit
              }

              handleNext={
                handleNext
              }

              setOriginalCost={
                setOriginalCost
              }

              productRef={
                productRef
              }

              setProductMonth={
                setProductMonth
              }

              setProductKm={
                setProductKm
              }

              setDeductibleType={
                setDeductibleType
              }

              setDeductible={
                setDeductible
              }

              shouldShow={true}
            />

          </TabPanel>

        )
      )}

    </Box>
  );
};

export default PricingTabBR;